<template>
	<div>
		<Layout :navFixed="true" :withImage="false" hideCart="true" hideMenu="true" hideFooter="true" class="bg-white">
			<!-- :background="require('@/assets/img/bg-middle.gif')" -->
			<Checkout />
		</Layout>
	</div>
</template>

<script>
import Layout from '@/components/Layout'
import Checkout from '@/components/ecommerce/Checkout'

export default {
	name: 'CheckoutPage',
	metaInfo: {
		title: 'Finalizar compra',
	},
	components: {
		Layout,
		Checkout,
	},
}
</script>

<style scoped></style>
